{
    "account": {
        "menu": {
            "general_infos": "General information",
            "company": "Company",
            "orders_history": "Orders history",
            "quotes_history": "Offers history",
            "invoices_history": "Invoices history",
            "logout": "Logout"
        },
        "general_infos": {
            "title": "General information",
            "account_infos": "Account information",
            "user_name": "Username",
            "user_email": "E-mail",
            "user_role": "Role",
            "user_mobile": "Mobile nr.",
            "change_password": "Change password",
            "agency_infos": "Company information",
            "customer_code": "Customer code",
            "company": "Company name",
            "vat": "VAT number",
            "activity": "Business sector",
            "workers": "Employees",
            "phone": "Phone nr.",
            "country": "Country",
            "province": "State/County",
            "city": "City",
            "zip": "ZIP code",
            "address": "Address"
        },
        "company": {
            "title": "Company information",
            "company": "Company name",
            "customer_code": "Customer code",
            "name": "Name",
            "vat": "VAT number",
            "business": "Business sector",
            "workers": "Employees",
            "phone": "Phone nr.",
            "country": "Country",
            "province": "State/County",
            "city": "City",
            "zip": "ZIP code",
            "address": "Address",
            "operational_users": "Authorized operators",
            "table": {
                "user_name": "Username",
                "email": "Email",
                "phone": "Mobile nr."
            },
            "no_companies_found": "No companies found"
        },
        "orders_history": {
            "title": "Orders history",
            "label_select_company": "View orders:",
            "doc_number": "Document number",
            "doc_number_placeholder": "ex. 0046100300300",
            "from": "from",
            "to": "to",
            "search_order": "Order search",
            "nothing_found": "No orders found",
            "error_reorder": "An error occurred.",
            "table": {
                "order": "Order",
                "date": "Date",
                "total": "Total amount",
                "order_status": "Order status",
                "reorder": "Reorder",
                "load_more": "Load more orders"
            }
        },
        "quotes_history": {
            "title": "Quotations history",
            "label_select_company": "View quotations:",
            "doc_number": "Document number",
            "doc_number_placeholder": "ex. 0046100300300",
            "from": "from",
            "to": "to",
            "search_quote": "Search quotation",
            "nothing_found": "No quotations found",
            "table": {
                "quote": "Quotation",
                "date": "Date",
                "new_offer": "New quotation",
                "quote_status": "Quotation status",
                "load_more": "Load more quotations"
            }
        },
        "invoices_history": {
            "title": "Invoices history",
            "label_select_company": "View payments status:",
            "expired_invoices": "Expired invoices",
            "expiring_invoices": "Expiring invoices",
            "payment_method": "Payment method",
            "billing_address": "Billing address",
            "nothing_found": "No invoice found",
            "table": {
                "invoice_number": "Invoice number",
                "date": "Invoice date",
                "expiring_date": "Expiry date",
                "payment_method": "Payment method",
                "value": "Due amount",
                "invoice_status": "Invoice status",
                "currency": "Currency",
                "download": "Download",
                "load_more": "Load more invoices",
                "error_download": "Error during invoice download"
            }
        },
        "order_detail": {
            "title": "Order",
            "go_back": "Back",
            "download": "Download",
            "your_reference": "Your order nr.",
            "date_order": "Order date",
            "weight": "Weight (Kgs)",
            "payment": "Payment terms",
            "return_terms": "Delivery terms",
            "billing_address": "Billing address",
            "shipping_address": "Shipping address",
            "table": {
                "art_code": "Product code",
                "art_code_customer": "Customer product code",
                "description": "Description",
                "measure_unit": "UM",
                "total_quantity": "Total quantity",
                "unit_price": "Unit price",
                "discount_1": "Discount 1",
                "discount_2": "Discount 2",
                "discount_3": "Discount 3",
                "increase": "Increase",
                "net_unit_price": "Net price",
                "net_total": "Net amount",
                "deliver_date": "Delivery date"
            }
        },
        "quote_detail": {
            "title": "Quotation",
            "go_back": "Back",
            "download": "Download",
            "your_reference": "Your reference",
            "date_quote": "Quotation date",
            "weight": "Weight (Kgs)",
            "payment": "Payment terms",
            "return_terms": "Delivery terms",
            "billing_address": "Billing address",
            "shipping_address": "Shipping address",
            "table": {
                "art_code": "Product code",
                "art_code_customer": "Customer product code",
                "description": "Description",
                "measure_unit": "UM",
                "total_quantity": "Total quantity",
                "unit_price": "Unit price",
                "discount_1": "Discount 1",
                "discount_2": "Discount 2",
                "discount_3": "Discount 3",
                "increase": "Increase",
                "net_unit_price": "Net price",
                "net_total": "Net amount",
                "deliver_date": "Delivery date"
            }
        },
        "document_status_list": {
            "pending": "pending",
            "delivering": "delivering",
            "delivered": "delivered",
            "processed": "shipped",
            "invoiced": "invoices",
            "refused": "declined",
            "accepted": "accepted",
            "on_customer_approve": "pending customer approval",
            "on_offer_progress": "quotation pending",
            "canceled": "canceled",
            "expired": "expired",
            "expiring": "expiring",
            "paid": "paid",
            "active": "active",
            "created": "created",
            "approved": "approved",
            "cancelled": "canceled",
            "confirmed": "confirmed"
        },
        "totals_component": {
            "text": "The General conditions of supply available on www.gberardi.com apply to all sales contracts by BERARDI BULLONERIE s.r.l.. Differing contractual conditions, even if contained in the customer's general or special conditions of purchase, shall be inapplicable and shall not bind BERARDI BULLONERIE s.r.l. unless the latter expressly accepts them in writing.",
            "products_total": "Total products",
            "discount": "Discount",
            "net_total": "Net amount",
            "packaging": "Packaging/other charges",
            "shipment": "Freight cost",
            "order_total": "Total order amount"
        }
    },
    "cart": {
        "cart_title": "My shopping cart",
        "login_to_receive_quotation": "Log in or sign up to request a quotation.",
        "proceed_to_checkout": "Proceed to checkout.",
        "minimum_order_total": "Minimum order amount is 200,00€",
        "code": "Product code",
        "details": "details",
        "request_quotation": "Request quotation",
        "request_quotation_text": "Send a request for the item in your shopping cart. Our customer service will contact you with a personalized offer.",
        "quote_all": "Request quotation for all items",
        "quote": "quotation",
        "order_detail": "Order detail",
        "total_items": "Total products",
        "subtotal": "Subtotal",
        "quantity_discount": "Quantity discount",
        "total_no_vat": "Amount excl. VAT",
        "vat": "VAT",
        "total": "Amount incl. VAT",
        "quote_request": "Quotation request",
        "pieces": "Pieces",
        "pieces_short": "pcs",
        "quote_request_text": "The subtotal is provisional. The quotation may change in case of high quantities.",
        "proceed": "Proceed",
        "csv_box_title": "Do you want to load the shopping cart from your product list?",
        "csv_box_text": "Load your .csv file with the desired product codes and quantities.",
        "csv_box_text_instructions": "If your item code is registered in our system, please insert it under the column CUSTOMER_CODE",
        "csv_box_no_file": "No .csv loaded",
        "csv_select_file": "Select file",
        "csv_download": "Download template",
        "csv_upload": "Upload",
        "unit_price": "Unit price",
        "error_uploading_csv": "Errore uploading CSV file",
        "summary": {
            "title": "Summary",
            "subtitle": "Send your request to our customer service. You can check the status of your requests in your customer area.",
            "order_summary": "Order summary",
            "addresses": "Addresses",
            "billing_address": "Billing address",
            "shipping_address": "Shipping address",
            "additional_info": "Additional information",
            "your_reference": "Your reference",
            "input_reference": "Insert reference",
            "note": "Notes",
            "input_note": "Insert note",
            "order_items": "Ordered products",
            "items_total": "Items total",
            "discount": "Discount",
            "order_total": "Order total",
            "order_total_quote": "Quotation request",
            "quote_summary": "Quotation summary",
            "input_note_quote": "Add notes to quotation",
            "quote_items": "Quoted products",
            "disclaimer": "The General conditions of supply available on www.gberardi.com apply to all sales contracts by BERARDI BULLONERIE s.r.l.. Differing contractual conditions, even if contained in the customer's general or special conditions of purchase, shall be inapplicable and shall not bind BERARDI BULLONERIE s.r.l. unless the latter expressly accepts them in writing.",
            "send": "Send",
            "error_send_order_quote": "An error occurred during order transmission"
        },
        "thank_you": {
            "thank_you_title": "Thank you for choosing us!",
            "for_more_info": "We have received your request. You can check the status of your requests in your customer area.",
            "back_to_home": "Back to home",
            "order_title": "Order",
            "order_title_failed": "Order sent",
            "order_not_success": "Your order has to be checked by one of our operators. As soon as it is verified, you will find it in your Orders History",
            "order_success": "The order was sent correctly. You will soon be able to monitor the order status in your customer area.",
            "items_number": "Number of products",
            "quote_title": "Quotation request sent",
            "quote_success": "You will receive our quotation from one of our operators over the next hours",
            "quote_not_success": "Your quotation has to be checked by one of our operators. You will receive it as soon as possible."
        }
    },
    "product": {
        "buttons": {
            "tech_sheet_download": "Download data sheet",
            "compliance_sheet_download": "Download compliance sheet"
        },
        "table_data": {
            "code": "Code",
            "color": "Color",
            "brand": "Brand",
            "material": "Material"
        },
        "filters": {
            "sku": "Product Code"
        },
        "table": {
            "art_code": "Item Code",
            "art_code_customer": "Cust. Item Code",
            "weight": "Weight",
            "pieces_per_package": "Pcs/box",
            "unit_price": "Unit price",
            "total_price": "Total amount",
            "number_of_pieces": "Nr. of pieces",
            "availability": "Availability",
            "associate": "Associate",
            "login_to_see_price": "Log in to view price",
            "pieces": "Pieces",
            "details": "details",
            "insufficient_qty": "Partial q.ty available",
            "not_available": "Not available",
            "available": "In stock",
            "load_more_variants": "Load other variants",
            "added_product": "Product added to cart: "
        },
        "clothing_selector": {
            "add_to_cart": "Add to cart",
            "color": "Color",
            "size": "Size",
            "unit_price": "Unit price",
            "pieces_number": "Nr. of pieces",
            "total_price": "Total amount",
            "insufficient_qty": "Partial q.ty available",
            "not_available": "Not available",
            "available": "In stock"
        }
    },
    "modals": {
        "general": {
            "confirm": "Confirm",
            "cancel": "Cancel"
        },
        "associate_id": {
            "title": "Customer product code",
            "paragraph": "Insert your product code to associate with our product code.",
            "customer_code": "Customer product code",
            "placeholder": "Insert customer product code",
            "warning_text": "Warning! You can modify this field only once!",
            "explanation_confirm": "Make sure your product code is correct and confirm association. After you have associated the code, you will not be able to change it further without assistance. To modify the customer product code further, please contact Berardi's customer service.",
            "associate_button": "Associate"
        }
    },
    "search": {
        "search_code": "Search code...",
        "cod_art": "Product code",
        "name_art": "Product name",
        "no_product_found": "No product found",
        "no_query": "Type into the search bar and press ENTER to view results"
    },
    "general": {
        "login": "Log in",
        "sign_up": "Sign up",
        "select": "Select"
    }
}
